var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"container-fluid h-100",attrs:{"id":"app"}},[_c('b-row',{staticClass:"h-100 justify-content-center align-items-center"},[_c('b-col',{attrs:{"cols":"12","xl":"6","md":"8"}},[_c('div',{staticClass:"text-center"},[_c('FundacionLogo')],1),_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }